// Because there really can be only one reducer in Redux
// it must be combined. This combines all the reducers.
// Read more: https://redux.js.org/api-reference/combinereducers 

import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';

import { companyReducer } from './companyReducer';
import { terminalReducer } from './terminalReducer'; 
import { modalReducer } from './modalReducer';
import { generalReducer } from './generalReducer';
import { partReducer } from "./partReducer";
import { userReducer } from "./userReducer";
import { stationReducer } from "./stationReducer";
import { snackbarReducer } from "./snackbarReducer";
import { terminalSwitchReducer } from "./terminalSwitchReducer";
import { searchReducer } from "./searchReducer";



const rootReducer = combineReducers({
  oidc: oidcReducer,
  company: companyReducer,
  terminal: terminalReducer,
  part: partReducer,
  stationPump: stationReducer,
  general: generalReducer,
  modal: modalReducer,
  user: userReducer,
  snackbar: snackbarReducer,
  terminalSwitch: terminalSwitchReducer,
  searchField: searchReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js